import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { DatasetVersionReport } from '../../../types/dataset';
import { getReportDates } from './DatasetReport';

type Props = {
  selectedReportsSorted: DatasetVersionReport[];
};

const MAX_BAR_THICKNESS = 80;

export const DatasetReportGraphs = ({ selectedReportsSorted }: Props) => {
  const [fileCountDataset, setFileCountDataset] = useState<any>();
  const [uniqueTagDataset, setUniqueTagDataset] = useState<any>();
  const [lanDatasets, setLanDatasets] = useState<any[]>([]);
  const [lanLabels, setLanLabels] = useState<any[]>([]);

  useEffect(() => {
    const fileCountData1 = {
      label: getReportDates(selectedReportsSorted).timeCreated0,
      data: [selectedReportsSorted[0].file_count],
      backgroundColor: ['rgba(255, 138, 153, 0.6)'],
      maxBarThickness: MAX_BAR_THICKNESS,
    };
    let fileCountData2 = null;
    if (selectedReportsSorted.length === 2) {
      fileCountData2 = {
        label: getReportDates(selectedReportsSorted).timeCreated1,
        data: [selectedReportsSorted[1].file_count],
        backgroundColor: ['rgba(255, 92, 128, 0.6)'],
        maxBarThickness: MAX_BAR_THICKNESS,
      };
    }
    fileCountData2 ? setFileCountDataset([fileCountData1, fileCountData2]) : setFileCountDataset([fileCountData1]);
  }, [selectedReportsSorted]);

  useEffect(() => {
    const uniqueTagData1 = {
      label: getReportDates(selectedReportsSorted).timeCreated0,
      data: [selectedReportsSorted[0].tags.length],
      backgroundColor: ['rgba(255, 138, 153, 0.6)'],
      maxBarThickness: MAX_BAR_THICKNESS,
    };
    let uniqueTagData2 = null;
    if (selectedReportsSorted.length === 2) {
      uniqueTagData2 = {
        label: getReportDates(selectedReportsSorted).timeCreated1,
        data: [selectedReportsSorted[1].tags.length],
        backgroundColor: ['rgba(255, 92, 128, 0.6)'],
        maxBarThickness: MAX_BAR_THICKNESS,
      };
    }
    uniqueTagData2 ? setUniqueTagDataset([uniqueTagData1, uniqueTagData2]) : setUniqueTagDataset([uniqueTagData1]);
  }, [selectedReportsSorted]);

  useEffect(() => {
    if (selectedReportsSorted.length) {
      setLanDatasets([]);
      const getAllLanguages = selectedReportsSorted.reduce(
        (prev: string[], curr) => prev.concat(curr.tags.map(tagCount => tagCount.tag.substring(0, 2))),
        []
      );
      const uniqueLanguageOptions = getAllLanguages.reduce((prev: string[], curr) => {
        return prev.includes(curr) ? prev : [...prev, curr];
      }, []);
      setLanLabels(uniqueLanguageOptions);
      const dataset1 = {
        label: getReportDates(selectedReportsSorted).timeCreated0,
        data: uniqueLanguageOptions.map((lan: string) => {
          return selectedReportsSorted[0].tags.reduce((prev, curr) => {
            return curr.tag.substring(0, 2) === lan ? prev + curr.count : prev;
          }, 0);
        }),
        backgroundColor: 'rgba(24,22,143,0.4)',
        maxBarThickness: MAX_BAR_THICKNESS,
      };
      let dataset2 = null;
      if (selectedReportsSorted.length === 2) {
        dataset2 = {
          label: getReportDates(selectedReportsSorted).timeCreated1,
          data: uniqueLanguageOptions.map((lan: string) => {
            return selectedReportsSorted[1].tags.reduce((prev, curr) => {
              return curr.tag.substring(0, 2) === lan ? prev + curr.count : prev;
            }, 0);
          }),
          backgroundColor: 'rgba(84,43,183,0.4)',
          maxBarThickness: MAX_BAR_THICKNESS,
        };
      }
      dataset2 ? setLanDatasets([dataset1, dataset2]) : setLanDatasets([dataset1]);
    }
  }, [selectedReportsSorted]);

  const languageCountData = {
    labels: lanLabels,
    datasets: lanDatasets,
  };

  const options = {
    indexAxis: 'x',
    maintainAspectRatio: false,
    scales: {
      y: {
        suggestedMin: 0,
      },
    },
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'File Count',
        font: { size: '16px' },
      },
    },
  };

  const options2 = {
    ...options,
    plugins: {
      title: {
        display: true,
        text: 'Unique Tags',
        font: { size: '16px' },
      },
    },
  };

  const options3 = {
    ...options,
    plugins: {
      title: {
        display: true,
        text: 'Languages',
        font: { size: '16px' },
      },
    },
  };

  const fileCountData = {
    labels: ['file count'],
    datasets: fileCountDataset,
  };

  const uniqueTagData = {
    labels: ['number of unique tags'],
    datasets: uniqueTagDataset,
  };

  return (
    <div>
      <Row>
        <Col span={11}>
          <Bar data={fileCountData} options={options} style={{ height: 250 }} />
        </Col>
        <Col span={11} offset={2}>
          <Bar data={uniqueTagData} options={options2} style={{ height: 250 }} />
        </Col>
      </Row>
      <div className="mt-10">
        <Bar data={languageCountData} options={options3} style={{ height: 250 }} />
      </div>
    </div>
  );
};
